import { useMutation } from "@tanstack/react-query";
import { callApi } from "../../utils/ApiCallPostOnly";

export const useCreateReturn = () => {
  return useMutation({
    mutationFn: (data) =>
      callApi({
        path: "convertinvoice",
        command: "",
        data: JSON.stringify(data),
      }),
  });
};
